// Portuguese (pt-BR) UI strings. Extracted verbatim from viewer.js (UI.pt).
// HTML markup in values is preserved intentionally.

import type { UIStrings } from './index';

export const pt: UIStrings = {
  'header.walkHint':         '<kbd>←</kbd> <kbd>→</kbd> caminhar · arraste vazio para pan',
  'header.docs':             'docs',
  'header.share.title':      'Compartilhar',
  'header.settings.title':   'Configurações',
  'header.code.title':       'Ver código-fonte',
  'header.zoom.title':       'Zoom',
  'header.zoom.fit':         'Caber na tela',
  'header.search.title':     'Buscar (⌘K)',
  'search.placeholder':      'Buscar nodes…',
  'search.empty':            'Nenhum node encontrado.',
  'code.eyebrow':            'código',
  'code.title':              'Código <em>· fonte bruta</em>',
  'code.copy':               'Copiar',
  'code.download':           'Baixar',
  'code.empty':              'Nenhum código-fonte disponível para este mapa.',
  'code.undo':               'Desfazer (⌘Z)',
  'code.redo':               'Refazer (⌘⇧Z)',
  'code.status.saved':       'aplicado',
  'code.status.editing':     'editando',
  'code.status.error':       'inválido — mantendo anterior',
  'loading':                 'Carregando dados do lifecycle…',
  'splash.title':            'lifecycle-map <em>— viewer</em>',
  'splash.eyebrow':          'visualizador interativo de lifecycle em swim-lane',
  'splash.lead':             'Renderize qualquer mapa de lifecycle a partir de JSON ou YAML. Cinco formas de carregar:',
  'splash.example.h':        'Experimente um exemplo →',
  'splash.example.p':        'Carregue o exemplo do pipeline de contratação para explorar o schema e as interações.',
  'splash.exampleMl.h':      'Experimente multi-idioma →',
  'splash.exampleMl.p':      'Um exemplo menor com strings em <code>en</code>, <code>pt</code>, e <code>es</code>. Troque o idioma em <strong>Configurações → Idioma</strong>.',
  'splash.url.h':            'Carregar por URL → <code>?src=https://…</code>',
  'splash.url.p':            'Passe uma URL de JSON ou YAML como parâmetro. Funciona com Gists públicos, URLs raw do GitHub, ou qualquer endpoint com CORS.',
  'splash.hash.h':           'Embutir na URL → <code>#data=…</code>',
  'splash.hash.p':           'URLs auto-contidas com JSON comprimido em gzip no fragment. Ótimo para agentes de IA — sem hospedagem.',
  'splash.dnd.h':            'Ou só arraste um arquivo →',
  'splash.dnd.p':            'Solte um arquivo <code>.json</code> ou <code>.yaml</code> em qualquer lugar desta página.',
  'splash.paste.h':          'Cole JSON ou YAML',
  'splash.paste.render':     'Renderizar',
  'splash.paste.cancel':     'Cancelar',
  'splash.footer.docs':      'Documentação',
  'splash.footer.github':    'GitHub',
  'splash.footer.license':   'Licença MIT',
  'settings.title':          'Configurações <em>· do seu jeito</em>',
  'settings.theme':          'Tema',
  'settings.appearance':     'Aparência',
  'settings.language':       'Idioma',
  'settings.uiLanguage':     'Idioma da interface',
  'settings.dataLanguage':   'Idioma do mapa',
  'settings.mode.light':     'Claro',
  'settings.mode.dark':      'Escuro',
  'settings.foot.docs':      'Ler os docs',
  'settings.foot.github':    'Ver no GitHub',
  'settings.foot.license':   'Licença MIT',
  'dnd.title':               'Solte para carregar',
  'dnd.sub':                 'Solte em qualquer lugar — vamos parsear JSON ou YAML',
};
